export enum OrganizationType {
  ORG_PARTNER = 'ORG_PARTNER',
  PUBLIC = 'PUBLIC',
  ON_BOARDED = 'ON_BOARDED',
  RELATED = 'RELATED'
}
